import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    Grid,
    Card,
    CardContent,
    withStyles,
} from '@material-ui/core';

const styles = theme => ({
    cardOverflowVisible: {
        overflow: 'visible',
    },
    highlighted: {
        background: theme.palette.background.highlightedCard,
    },
});

const GridCard = ({
    children,
    classes,
    cardOverflowVisible,
    highlighted,
    ...otherProps
}) => (
    <Grid item {...otherProps}>
        <Card
            className={classNames({
                [classes.cardOverflowVisible]: cardOverflowVisible,
                [classes.highlighted]: highlighted,
            })}
        >
            <CardContent>
                {children}
            </CardContent>
        </Card>
    </Grid>
);

GridCard.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    cardOverflowVisible: PropTypes.bool,
    highlighted: PropTypes.bool,
};

GridCard.defaultProps = {
    cardOverflowVisible: false,
    highlighted: false,
};

export default withStyles(styles)(GridCard);
